import { Route } from 'vue-router'
import rootStore from '@vue-storefront/core/store'
import { isServer } from '@vue-storefront/core/helpers'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { router } from '@vue-storefront/core/app'

export async function beforeEach(to: Route, from: Route, next) {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth)
  if (requiresAuth && !isServer) {
    try {
      await rootStore.dispatch('user/startSession')
    } catch (error) {
      next(error)
      return
    }
    if (!rootStore.getters['user/isLoggedIn']) {
      const storeView = currentStoreView()
      const url = ((storeView && storeView.url) || '').replace(/\/$/, '')
      const { href } = router.resolve({
        path: (url || '') + '/login',
        query: {
          redirectTo: to.fullPath,
          redirect: from.path
        }
      })

      next(false)
      window.location.replace(href)
      return
    }
  }
  next()
}
